// HomePage.const.ts

// Section 1: Main Header Content
export const SECTION_ONE_CONTENT = {
  HEADER: "Upptäck och testa hur dina känslor påverkar dig och ditt sparande.",
  DESCRIPTION:
    "Gör Empathys test och ta del av dina olika känsloreaktioner och emotioner vid upp- och nedgångar i värdet på ditt sparande över olika tidsperioder.",
  BUTTONS: {
    PRIMARY: "Ta mig till Empathytestet",
    SECONDARY: "Så funkar EQ",
  },
};

// Section 2: Emotional Intelligence
export const EMOTIONAL_INTELLIGENCE = {
  HEADER: "Emotionell intelligens",
  SUBHEADER: "Vad är det?",
  DESCRIPTIONS: {
    PRIMARY:
      "Du har antagligen någon gång känt dig ledsen, arg eller glad över utvecklingen på ditt sparande.",
    SECONDARY:
      "Emotionell intelligens hjälper oss att förstå hur vi använder våra egna och andras känslor vid dessa tillfällen. Det är en superkraft som förbättrar ditt beslutsfattande.",
    SUPPORTING: "Hur stödjer denna superkraft dig?",
    CONCLUSION:
      "Emotionell intelligens handlar om att vara streetsmart med dina känslor när du sparar, vilket gör dig till en bättre investerare och får dig att må bättre. Nästa gång du känner något om ditt sparande, använd din emotionella intelligens",
  },
  LIST_ITEMS: [
    "Du vet när du är glad, ledsen eller arg",
    "Du kan hantera dina känslor och lugna ner dig när du upplever ilska eller ledsamhet",
    "Du kan förstå andras känslor och hjälpa en ledsen vän eller ge stöd",
  ],
};

// Section 3: Graph Content
export const GRAPH_SECTION = {
  HEADER: "EQ, marknadsutveckling och tid",
  SUBHEADERS: {
    FIRST: "Aktieindex",
    SECOND: "Utveckling",
  },
  EQ140: "EQ: ",
  TIME: "Tid: ",
  BUTTON_TEXT_PRIMARY: "Ta mig till Empathytestet",
  BUTTON_TEXT_SECONDARY: "Så funkar EQ",
  TEXT_ITEMS: [
    'Efter att ditt sparande har stigit med +20% i värde på en månad känner du dig helt överraskad. Det är som när något plötsligt och spännande händer och du säger "oj!"',
    "Efter att ditt sparande minskat med -10 % i värde, bortser du från allt du tidigare har lärt dig och känner dig nedstämd, utan att riktigt förstå varför. Din vilja att agera påverkas också negativt.",
    "Efter att ditt sparande har sjunkit med -20% i värde på en månad känner du inte längre att du vill följa de råd du får eller vad du trodde skulle hända. Det är som när du inte vill lyssna på goda råd.",
    "Efter att värdet på ditt sparande ökat med 10% på en månad funderar du på framtiden, likt spänningen i en intressant berättelse. Du fokuserar på vad du vet och tänker logiskt i stället för att låta känslorna styra. Genom att använda din kunskap och tänka klart, känner du dig säkrare och lugnare i dina beslut.",
  ],
};

// Section 5: Information Section
export const EMOTIONAL_STRATEGY_SECTION = {
  HEADING: "Hur tar du hand om dina känslor, din ekonomi och ditt sparande?",
  HEADING_Emotinel: "Emotionell strategi",
  SUB_HEADING_1:
    "Om du använder dina känslomässiga drivkrafter så utvecklar du din egen emotionella sparstrategi.",
  SUB_HEADING_1_1: "Denna hjälper dig att:",
  SUB_HEADING_2: "Bli emotionellt strategisk",
  LIST_ITEMS_DASHED: [
    "fatta klokare känslomässiga beslut.",
    "använda dina känslor när du fattar beslut om att öka eller minska ditt sparande.",
    "förstå ditt sparande känslomässigt, både på kort och lång sikt.",
    "hantera dina känslor och emotioner när marknaden svänger kraftigt eller oväntat.",
  ],
  LIST_ITEMS_NUMBERED: [
    "Lär dig hantera dina känslor när marknaden går upp och ner.",
    "Minska impulsiva känslor som annars kan riskera att leda till oönskade utfall.",
    "Stärk din känslomässiga medvetenhet samtidigt som du behåller fokus på dina finansiella mål.",
    "Begränsa överdriven känslopåverkan och sprider/fördelar risker på ett balanserat sätt.",
    "Använd dina känslor och intuition för att bättre förstå marknadstrender och andra investerares beteenden.",
  ],
};

export const INFORMATION_SECTION = {
  HEADING: "Få reda på din EQ",
  SUB_HEADING: "Emotionell strategi",
  LIST_ITEMS: [
    "Testet innehåller ett antal frågor om hur du känner i olika situationer eller hur du vanligtvis använder dina emotioner. Frågorna har flera svarsalternativ.",
    "Välj det alternativ som du anser passar bäst in på dig.  Det finns inga svar som är rätt eller fel.",
    "Det är mycket viktigt att du svarar ärligt.",
    "När du har besvarat frågorna så kommer du att få ett resultat som beskriver hur du förhåller dig i tanke och känsla till olika situationer för ditt sparande.",
  ],
  PARAGRAPHS: {
    FIRST:
      "Empathys test hjälper dig att förstå hur dina emotioner påverkar dina beslut.",
    SECOND:
      "Empathytestet är enkelt och resultatet du får beskriver hur du ligger i förhållande till skalan över EQ-normen i Sverige. Du får dessutom förslag på vad du skall vara vaksam på rörande känslor och emotioner runt ditt sparande.",
  },
};

// Section 6: Testimonials
export const TESTIMONIALS_SECTION = {
  TITLE: "Kundomdömen",
  FEEDBACKS: [
    {
      NAME: "Staffan",
      ROLE: "Investerare",
      TEXT: "Viktigt att man läser igenom instruktion till testet och introduktion till EQ för att få maximal nytta. Smidig och intuitivt gränssnitt.",
    },
    {
      NAME: "Ulrika",
      ROLE: "Egen företagare",
      TEXT: "Intressant och värdefullt.",
    },
    {
      NAME: "Ville",
      ROLE: "Student",
      TEXT: "Intressant med korrelationen mellan EQ och sparande. Introduktionstexter om EQ var belysande och testet roligt.",
    },
    {
      NAME: "Henrik",
      ROLE: "Journalist",
      TEXT: "Tack vare hjälpen från Empathytestet har jag nu ett klart bättre självförtroende i mina sparandebeslut.",
    },
  ],
  BUTTON_TEXT: "Ta mig till Empathytestet",
};

// Select Options
export const SELECT_OPTIONS = {
  EQ: [
    { value: "80", label: "80" },
    { value: "140", label: "140" },
  ],
  TIME: [
    { value: "1 Månad", label: "1 Månad" },
    { value: "1 År", label: "1 År" },
    { value: "5 År", label: "5 År" },
  ],
  RESULT: [
    { value: "Stress", label: "Stress" },
    { value: "Motivation", label: "Motivation" },
    { value: "Empati", label: "Empati" },
  ],
};

export const CHART_ERROR_MSG =
  "Det gick inte att ladda data. Försök igen senare.";
